<div class="card">
    <div class="card-header">
        <p class="card-title">
            Segmentos
        </p>
        <span class="badge badge-pill badge-secondary-light">
            <ng-template [ngIf]="isLoading">
                <i class='fas fa-spinner fa-pulse'></i>
            </ng-template>
            <ng-template [ngIf]="!isLoading && isLoaded">
                {{(entities?.length ? entities?.length : 0) | decimalFormat: 1:0:0}}
            </ng-template>                
        </span>       
    </div>

    <div class="card-body" *ngIf="isLoading">
        <p class="text-center" *ngIf="isLoading">
            <i class='fas fa-spinner fa-pulse'></i> Carregando o segmentos
        </p>
    </div>

    <div class="card-body" *ngIf="isLoaded && (!entities || entities.length === 0)">
        <p class="text-center">
            Nenhum segmento
        </p>    
    </div>               

    <ng-template [ngIf]="isLoaded && entities?.length > 0">
        <ul class="list-group list-group-flush">
            <li class="list-group-item" *ngFor="let entity of entities">
                <sgt-cliente-analise-mercado-projecao-progress
                    title="{{entity.classificacoesNome}}"
                    [controleQuantidade]="controleQuantidade"
                    [controlePeso]="controlePeso"
                    [controleValor]="controleValor"
                    [quantidadeProjetada]="entity.quantidadeProjetada"
                    [pesoProjetado]="entity.pesoProjetado"
                    [valorProjetado]="entity.valorProjetado"
                    [quantidadeRealizada]="entity.quantidadeRealizada"
                    [quantidadeRealizadaPerc]="entity.quantidadeRealizadaPercProjetada"
                    [pesoRealizado]="entity.pesoRealizado"
                    [pesoRealizadoPerc]="entity.pesoRealizadoPercProjetado"
                    [valorRealizado]="entity.valorRealizado"
                    [valorRealizadoPerc]="entity.valorRealizadoPercProjetado">
                </sgt-cliente-analise-mercado-projecao-progress>                    
            </li>
        </ul>
    </ng-template>
</div>